import { PasswordSetupPage } from './features/common/PasswordSetupPage';
import { createBrowserRouter } from 'react-router';
import { SessionGate } from './shell/SessionGate';
import { AppShell } from './shell/AppShell';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { WarehouseWorkPage } from './features/dashboard/WarehouseWorkPage';
import { InventoryCountDetail, InventoryCountTasks } from './features/dashboard/InventoryCountTasks';
import { OrdersPage } from './features/orders/OrdersPage';
import { OrderDetailPage } from './features/orders/OrderDetailPage';
import { OrderCreatePage, OrderEditPage } from './features/orders/OrderCreatePage';
import { OrderStockFlowPage } from './features/orders/OrderStockFlowPage';
import { AppsPage, MePage, NotFoundPage } from './features/common/Pages';
import { AppearancePage } from './features/common/AppearancePage';
import { PasswordPage } from './features/common/PasswordPage';
import { AboutPage } from './features/common/AboutPage';
import { InstallGuidePage } from './features/common/InstallGuidePage';
import { NotificationSettingsPage } from './features/common/NotificationSettingsPage';
import { NotificationsPage } from './shell/NotificationCenter';
import { routes as inventoryRoutes } from './features/inventory/routes';
import { routes as productsRoutes } from './features/products/routes';
import { routes as partnersRoutes } from './features/partners/routes';
import { routes as adminRoutes } from './features/admin/routes';
import { routes as reportsRoutes } from './features/reports/routes';
import { routes as taobaoRoutes } from './features/taobao/routes';
import { routes as shipmentsRoutes } from './features/shipments/routes';
import { routes as exceptionsRoutes } from './features/exceptions/routes';
import { routes as settlementsRoutes } from './features/settlements/routes';

export const router = createBrowserRouter(
  [
    { path: 'password-setup', element: <PasswordSetupPage /> },
    {
      element: <SessionGate />,
      children: [
        {
          element: <AppShell />,
          children: [
            { index: true, element: <DashboardPage /> },
            { path: 'work', element: <WarehouseWorkPage /> },
            { path: 'work/counts', element: <InventoryCountTasks /> },
            { path: 'work/counts/:id', element: <InventoryCountDetail /> },
            { path: 'orders', element: <OrdersPage /> },
            { path: 'orders/new', element: <OrderCreatePage /> },
            { path: 'orders/:id/edit', element: <OrderEditPage /> },
            { path: 'orders/:id', element: <OrderDetailPage /> },
            { path: 'orders/:id/stock', element: <OrderStockFlowPage /> },
            ...inventoryRoutes,
            ...productsRoutes,
            ...partnersRoutes,
            ...adminRoutes,
            ...reportsRoutes,
            ...taobaoRoutes,
            ...shipmentsRoutes,
            ...exceptionsRoutes,
            ...settlementsRoutes,
            { path: 'apps', element: <AppsPage /> },
            { path: 'me', element: <MePage /> },
            { path: 'me/appearance', element: <AppearancePage /> },
            { path: 'me/password', element: <PasswordPage /> },
            { path: 'me/about', element: <AboutPage /> },
            { path: 'me/install', element: <InstallGuidePage /> },
            { path: 'me/notifications', element: <NotificationSettingsPage /> },
            { path: 'notifications', element: <NotificationsPage /> },
            { path: '*', element: <NotFoundPage /> },
          ],
        },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL.replace(/\/$/, '') || '/' },
);
